import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TrendingUp, Sparkles, Megaphone, Globe, Calendar, Heart } from 'lucide-react';

const Clients: React.FC = () => {
  // Client logos from assets folder
  const clients = [
    { id: 'client-1', name: 'Aamisha Foods', logo: '/clientlogo/Color_Drop_with_Aamisha_Foods.jpg', category: 'Food & Beverage' },
    { id: 'client-2', name: 'Arihant Hospital', logo: '/clientlogo/Color_Drop_with_Arihant_Hospital.jpg', category: 'Healthcare' },
    { id: 'client-3', name: 'Ashoka Hotel', logo: '/clientlogo/Color_Drop_with_Ashoka_Hotel.jpg', category: 'Hospitality' },
    { id: 'client-4', name: 'BookMyAcademe', logo: '/clientlogo/Color_Drop_with_BookMyAcademe.jpg', category: 'Education' },
    { id: 'client-5', name: 'Bunglow Makers', logo: '/clientlogo/Color_Drop_with_Bunglow_Makers.jpg', category: 'Real Estate' },
    { id: 'client-6', name: 'Dr. Abhijeet Bhasin', logo: '/clientlogo/Color_Drop_with_Dr_Abhijeet_Bhasin_Indore.jpg', category: 'Healthcare' },
    { id: 'client-7', name: 'Dr. Bhatia', logo: '/clientlogo/Color_Drop_with_Dr_Bhatia.jpg', category: 'Healthcare' },
    { id: 'client-8', name: 'Geet Dental Clinic', logo: '/clientlogo/Color_Drop_with_Geet_Dental_Clinic.jpg', category: 'Healthcare' },
    { id: 'client-9', name: 'INDWheels', logo: '/clientlogo/Color_Drop_with_INDWheels.jpg', category: 'Automotive' },
    { id: 'client-10', name: 'ISC', logo: '/clientlogo/Color_Drop_with_ISC.jpg', category: 'Education' },
    { id: 'client-11', name: 'Khalsa Pagree', logo: '/clientlogo/Color_Drop_with_Khalsa_Pagree.jpg', category: 'Retail' },
    { id: 'client-12', name: 'Manbhadra Fincorp', logo: '/clientlogo/Color_Drop_with_Manbhadra_Fincorp.jpg', category: 'Finance' },
    { id: 'client-13', name: 'Medab Overseas', logo: '/clientlogo/Color_Drop_with_Medab_Overseas.jpg', category: 'Healthcare' },
    { id: 'client-14', name: 'Millet Aahaar', logo: '/clientlogo/Color_Drop_with_Millet_Aahaar.jpg', category: 'Food & Beverage' },
    { id: 'client-15', name: 'Mushkil Asan Kendra', logo: '/clientlogo/Color_Drop_with_Mushkil_Asan_Kendra.jpg', category: 'Services' },
    { id: 'client-16', name: 'Oink', logo: '/clientlogo/Color_Drop_with_Oink.jpg', category: 'Food & Beverage' },
    { id: 'client-17', name: 'Olive Dental & Physio', logo: '/clientlogo/Color_Drop_with_Olive_Dental&Physio.jpg', category: 'Healthcare' },
    { id: 'client-18', name: 'Palomi School', logo: '/clientlogo/Color_Drop_with_Palomi_School.jpg', category: 'Education' },
    { id: 'client-19', name: 'Peekay Pharma', logo: '/clientlogo/Color_Drop_with_Peekay_Pharma.jpg', category: 'Healthcare' },
    { id: 'client-20', name: 'Peppa Pork', logo: '/clientlogo/Color_Drop_with_Peppa_Pork.jpg', category: 'Food & Beverage' },
    { id: 'client-21', name: 'Saish Caterers', logo: '/clientlogo/Color_Drop_with_Saish_Caterers.jpg', category: 'Food & Beverage' },
    { id: 'client-22', name: 'Sampoorna Sodani Diagnostic', logo: '/clientlogo/Color_Drop_with_Sampoorna_Sodani_Diagnostic.jpg', category: 'Healthcare' },
    { id: 'client-23', name: 'Sapna Sandwich Indore', logo: '/clientlogo/Color_Drop_with_Sapna_Sandwhich_Indore.jpg', category: 'Food & Beverage' },
    { id: 'client-24', name: 'Sigma Classes', logo: '/clientlogo/Color_Drop_with_Sigma_Classes.jpg', category: 'Education' },
    { id: 'client-25', name: 'Spirabiotec', logo: '/clientlogo/Color_Drop_with_Spirabiotec.jpg', category: 'Healthcare' },
    { id: 'client-26', name: 'Storm Overseas', logo: '/clientlogo/Color_Drop_with_Storm_Overseas.jpg', category: 'Healthcare' },
    { id: 'client-27', name: 'VDC', logo: '/clientlogo/Color_Drop_with_VDC.jpg', category: 'Technology' },
    { id: 'client-28', name: 'Veerjees', logo: '/clientlogo/Color_Drop_with_Veerjees.jpg', category: 'Retail' },
    { id: 'client-29', name: 'Vostok Herbals', logo: '/clientlogo/Color_Drop_with_Vostok_Herbals.jpg', category: 'Healthcare' },
    { id: 'client-30', name: 'Wilcure', logo: '/clientlogo/Color_Drop_with_Wilcure.jpg', category: 'Healthcare' },
  ];

  // const stats = [
  //   { icon: Building2, value: '500+', label: 'Happy Clients' },
  //   { icon: Award, value: '1000+', label: 'Projects Completed' },
  //   { icon: Users, value: '50+', label: 'Team Members' },
  //   { icon: TrendingUp, value: '98%', label: 'Client Satisfaction' },
  // ];

  const stats = [
    { icon: Megaphone, value: '1365+', label: 'Ad Campaigns Done' },
    { icon: Globe, value: '18+', label: 'Location Served' },
    { icon: Calendar, value: '12+', label: 'Years Experience' },
    { icon: Heart, value: '560', label: 'Satisfied Clients' },
  ];
  // eslint-disable-next-line
  const [selectedCategory, setSelectedCategory] = React.useState('All');

  const filteredClients = selectedCategory === 'All'
    ? clients
    : clients.filter(client => client.category === selectedCategory);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-primary-50 via-accent-50 to-primary-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-primary-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent-500 rounded-full blur-3xl"></div>
        </div>
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl mb-6"
            >
              <Sparkles className="w-8 h-8 text-white" />
            </motion.div>
            <h1 className="text-5xl md:text-6xl font-serif font-bold mb-6">
              Our <span className="text-gradient">Proud Clients</span>
            </h1>
            <p className="text-xl text-neutral-600 leading-relaxed mb-8">
              We've had the privilege of working with some of the most innovative and successful brands across various industries.
              Our clients trust us to deliver exceptional results that drive their business forward.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white border-b border-neutral-200">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: false }}
                className="text-center"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-r from-primary-500 to-accent-500 rounded-xl mb-4">
                  <stat.icon className="w-7 h-7 text-white" />
                </div>
                <div className="text-4xl font-serif font-bold text-gradient mb-2">{stat.value}</div>
                <div className="text-neutral-600 font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Category Filter */}
      {/* <section className="py-12 bg-neutral-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
            className="flex flex-wrap justify-center gap-4"
          >
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-primary-500 to-accent-500 text-white shadow-lg shadow-primary-500/25'
                    : 'bg-white text-neutral-700 hover:bg-primary-50 hover:text-primary-600 border border-neutral-200'
                }`}
              >
                {category}
              </button>
            ))}
          </motion.div>
        </div>
      </section> */}

      {/* Clients Grid */}
      <section className="py-24 bg-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-serif font-bold mb-4">
              Trusted by Industry Leaders
            </h2>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              From startups to Fortune 500 companies, we've helped businesses of all sizes achieve their digital goals.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-16">
            {filteredClients.map((client, index) => (
              <Link
                key={`${client.id}-${index}`}
                to={`/clients/${client.id}`}
                className="block"
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  viewport={{ once: false }}
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="group cursor-pointer"
                >
                  <div className="bg-white rounded-xl p-6 border-2 border-neutral-200 hover:border-primary-300 transition-all duration-300 shadow-sm hover:shadow-xl hover:shadow-primary-500/10 aspect-square flex items-center justify-center">
                    <div className="w-full h-full flex items-center justify-center overflow-hidden p-4">
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="w-full h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300 opacity-70 group-hover:opacity-100"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = 'none';
                          const parent = target.parentElement;
                          if (parent) {
                            parent.innerHTML = `<div class="text-center"><div class="text-2xl font-bold text-primary-600 mb-1">${client.name.charAt(0)}</div><div class="text-sm text-neutral-500">${client.name}</div></div>`;
                          }
                        }}
                      />
                    </div>
                  </div>
                </motion.div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-primary-500 to-accent-500">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
          >
            <h2 className="text-4xl font-serif font-bold text-white mb-6">
              Ready to Join Our Client Family?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Let's work together to create something extraordinary for your brand.
              Get in touch with us today and discover how we can help elevate your digital presence.
            </p>
            <a
              href="/contact"
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold hover:bg-accent-50 transition-colors duration-300 inline-flex items-center shadow-lg"
            >
              Get Started Today
              <TrendingUp className="w-5 h-5 ml-2" />
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Clients;

